<template>
  <div class="choice-character">
    <h2 class="title">Choisissez votre joueur</h2>

    <ul v-if="players">
      <li class="choice-character__single" v-for="(player, i) in players" @click="choiceCharacter" :data-player="player.name" :data-pos="i">
        <img :src="player.img" :alt="player.name">
        <p>{{ player.name }}</p>
      </li>
    </ul>

    <span style="display: none;">{{ getCharactersData }}</span>
  </div>
</template>

<script>
  import selectParent from 'select-parent';
  import Transition from '~mixins/Transition';

  export default {
    name: 'choice-character',
    mixins: [Transition],
    data() {
      return {
        players: this.$store.getters.getCharactersData,
        tmpPlayer: null,
      };
    },
    mounted() {
      this.eventPlayers();
    },
    methods: {
      eventPlayers() {
        this.playerDOM = document.querySelectorAll('.choice-character__single');
      },
      choiceCharacter(e) {
        let parent = selectParent('.choice-character__single', e.target);
        const self = this;

        if (!parent) {
          parent = e.target;
        }

        for (let y = 0; y < this.playerDOM.length; y += 1) {
          this.playerDOM[y].classList.add('leave');
        }

        this.$store.commit('setTmpPlayer', parent.getAttribute('data-player'));
        this.$store.commit('setCharactersPos', parseInt(parent.getAttribute('data-pos'), 10));

        parent.classList.add('active');

        setTimeout(() => {
          self.$router.push('/choisir-son-personnage-slide');
        }, 400);
      },
    },
    computed: {
      getCharactersData() {
        return this.$store.getters.getCharactersData;
      },
    },
    watch: {
      getCharactersData(n) {
        this.players = n;
      },
      players() {
        const self = this;

        setTimeout(() => {
          self.eventPlayers();
        }, 100);
      },
    },
  };
</script>


<style lang="scss">
  .choice-character {
    width: 80%;
    margin: -5% auto 0;

    @include mobile {
      padding-bottom: 50px;
    }

    h2 {
      margin-bottom: 50px;
    }

    ul {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      @include mobile {
        flex-wrap: wrap;
      }

      li {
        opacity: 0;
        width: 25%;
        max-width: 20%;
        cursor: pointer;
        @include defaultTransition(.4);

        @for $i from 1 through 4 {
          &:nth-child(#{$i}) {
            animation: appearBottom .4s .5s + .1 * $i forwards;
          }
        }

        @include mobile {
          margin-bottom: 50px;
          width: 45%;
          max-width: 45%;
        }

        &.leave {
          opacity: 0;
          // transform: translateY(50px);
        }

        // &.active.leave {
        //   transform: translateY(-50px);
        // }

        img {
          display: block;
          margin: auto;
          max-width: 90%;
          @include defaultTransition(.4);
        }

        p {
          margin-top: 10px;
          text-align: center;
          color: $blue;
          @include fontSize(20);
          @include defaultTransition(.4);
        }

        &:hover {
          img {
            opacity: .7;
          }

          p {
            color: $orange;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ChoiceCharacter.vue?f819683a